import React from "react"
import {createRoot} from "react-dom/client"
import createWebComponent from "lib/create-web-component"
import {StyleSheetManager} from "styled-components"
import {path} from "ramda"

/**
 * Renders a widget into the DOM. Shared by the monolithic entry (index.js) and
 * standalone supplemental entries so they can register without pulling in the
 * dynamic-import init logic.
 */
export const initWidget = async (Widget, {elementId, ...widgetProps}) => {
  let resolveRef

  const promise = new Promise(resolve => (resolveRef = resolve))
  const rootElement = document.getElementById(elementId)
  const reactRoot = createRoot(rootElement)

  // Note that params can be undefined
  const disableShadowDom = path(["params", "disableShadowDom"], widgetProps)
  if (disableShadowDom === "true") {
    reactRoot.render(
      <React.StrictMode>
        <StyleSheetManager>
          <Widget {...widgetProps} />
        </StyleSheetManager>
      </React.StrictMode>
    )
  } else {
    createWebComponent(() => <Widget {...widgetProps} />)
    reactRoot.render(
      <React.StrictMode>
        <mh-widget ref={resolveRef} />
      </React.StrictMode>
    )
  }

  return promise
}
